import { UserData } from '@dap/admin/types';

type Names = Pick<UserData, 'name' | 'givenName' | 'familyName'>;

export const getUserName = ({ name, givenName, familyName }: Names): string => {
  return name || [givenName, familyName].filter((val) => !!val).join(' ') || 'Unknown username';
};
